import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Globals } from '../globals';
import { map, catchError } from "rxjs/operators";
import { ConfigurationsService } from 'src/app/Service/configurations.service';

@Injectable({
    providedIn: 'root'
})

export class AssignMeterService {
    private httpHeader = new HttpHeaders();

    constructor(private http: HttpClient, private _global: Globals,private configService: ConfigurationsService) {

        this.httpHeader.append('Access-Control-Allow-Origin', '*');

    }

    //Method is used for Get Site Energy Meter List
    GetSiteEnergyMeterList(CompanyId: any, UserId: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'AssignEnergymeter' + '/GetCompanyWiseSiteEnergymeterList?companyId=' + CompanyId + '&userId=' + UserId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
  
    //Method is used for Assign Energy Meter
    AssignEnergymeter(CompanyId: any, UserId: any, EnergyMasterIds: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'AssignEnergymeter' + '/AssignEnergymeter?UserId=' + UserId + '&companyId=' + CompanyId + '&energymeterId=' + EnergyMasterIds;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }


    //Method to check Energy Meter Exist Mayank Dulera
    CheckEnergyMeterExist(Type: any, value:any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'AssignEnergyMeter' + '/CheckEnergyMeterExist?Type=' + Type + '&EnergyMeterId=' + value;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    
    // Get Meter parameter
    GetMeterParamValue(DeviceId) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'AssignEnergymeter' + '/GetMeterParamValue?DeviceId=' + DeviceId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Update Meter parameter
    UpdateMeterParamValue(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'AssignEnergymeter' + '/UpdateMeterParamValue';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
}
